export default class paths {
  static common = {
    signout: '/signout'
  };
  static advocates = {
    main: '/',
    forum: '/forum',
    forumNewTopic: '/forum/new-topic',
    forumCategories: '/forum/categories',
    forumTopic: '/forum/topic',
    news: '/news',
    practice: '/practice',
    practiceCase: '/practice/case',
    myprofile: '/myprofile',
    profile: '/profile',
    education: '/education',
    notFound: '/404',
    forbidden: '/403',
    gallery: '/gallery'
  };
}
